/** Fun display names for player sign-up (shared with venue kiosk). */
export const VENUE_RANDOM_PLAYER_NAMES = [
  'Ace Morgan', 'Bullseye Bill', 'Treble Tess', 'Shanghai Sue', 'Robin Hood', 'Oche Annie', 'Flight Path Pete',
  'Double Top Dan', 'Checkout Charlie', 'Ton-Eighty Tom', 'Barrel Bob', 'Wire Tap Walt', 'Black Dog Dave',
  'Corkscrew Casey', 'Feather Finley', 'Dartboard Dana', 'Sawdust Sam', 'Chalk Dust Chloe', 'Leg Shot Lou',
  'Bounce Out Benny', 'Wire Hanger Hank', 'Bed & Breakfast Bea', 'Madhouse Mira', 'Ton Machine Mike',
  'Spider Legs Spencer', 'Rubberband Rita', 'Clock Strikes Clara', 'Yardstick Yuri', 'Hammer Time Hannah',
  'Split Decision Sid', 'Cover Shot Cole', 'Fish Eye Finn', 'Red Wire Riley', 'Green Room Gwen',
  'Ice Breaker Izzy', 'Hot Wire Hugo', 'Cold Steel Stella', 'Copper Line Cal', 'Silver Tongue Sky',
  'Gold Flake Gary', 'Platinum Pat', 'Bronze Medal Mo', 'Steel Tip Steve', 'Soft Tip Sophie',
  'Flight School Frank', 'Landing Strip Lana', 'Bull Ring Bruno', 'Outer Ring Olive', 'Inner Ring Ira',
  'Match Play Manny', 'Leggy Larry', 'Set Point Selena', 'Break Shot Brenda',
];

export function pickRandomPlayerName() {
  const pool = VENUE_RANDOM_PLAYER_NAMES;
  return pool[Math.floor(Math.random() * pool.length)] || 'Checkout Charlie';
}

/** Split "Full Name" → { fullName, nickname } using first token as nickname fallback. */
export function namesFromRandomPick() {
  const fullName = pickRandomPlayerName();
  const nickname = fullName.split(/\s+/)[0] || fullName;
  return { fullName, nickname };
}
